import { colorKey } from './colors'

/**
 * Function to create an SVG element
 * @param {string} icon The name of the icon
 * @param {number} [width="18"] The width of the icon
 * @param {number} [height="18"] The height of the icon
 * @param {string} className The class name to apply to the icon
 * @param {string} fill The hex to apply as the SVG fill colour
 * @returns {Element} The SVG element
 */
export function createSvg (icon, width = 18, height = 18, className = 'icon', fill = null) {
  if (!width) width = 18
  if (!height) height = 18
  if (!className) className = 'icon'
  if (fill) {
    className = `${className} fill-${colorKey(fill)}`
  }
  const href = svgName(icon)
  const svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svgElem.setAttribute('class', className)
  svgElem.setAttribute('width', width.toString())
  svgElem.setAttribute('height', height.toString())
  const useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use')
  useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href)
  useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', href)
  svgElem.appendChild(useElem)
  return svgElem
}

/**
 * Function to create an SVG element text
 * @param {string} icon The name of the icon
 * @param {number} [width="18"] The width of the icon
 * @param {number} [height="18"] The height of the icon
 * @param {string} className The class name to apply to the icon
 * @param {string} fill The hex to apply as the SVG fill colour
 * @returns {string} The element string
 */
export function createSvgAsText (icon, width = 18, height = 18, className = 'icon', fill = null) {
  if (!width) width = 18
  if (!height) height = 18
  if (!className) className = 'icon'
  if (fill) {
    className = `${className} fill-${colorKey(fill)}`
  }
  const href = svgName(icon)
  return `<svg class="${className}" width="${width}" height="${height}"><use xlink:href="${href}" href="${href}"></use></svg>`
}

/**
 * Function to return a namespaced name for the SVG
 * @param {string} icon The name of the SVG
 * @returns {string} The namespaced name of the SVG
 */
export function svgName (icon) {
  return `#mosaic_icon_${icon}`
}
